export default __webpack_public_path__ + "static/fixblob-80d04de93b58a837f317d1a76d8aae54.png";